/**
 * Round 80 — A-C-12 Governance & Explainability
 *
 * Best-effort audit logger for intelligence views. Failures are
 * swallowed — this MUST NOT block any UI. Reads are restricted by
 * RLS to OWNER / ORG_ADMIN; writers can only insert their own row.
 */
import { supabase } from '@/integrations/supabase/client';

export type IntelligenceActionType =
  | 'view_explanation'
  | 'view_suggestion'
  | 'view_analytics'
  | 'view_training_visibility'
  | 'view_observed_impact';

export interface IntelligenceAuditPayload {
  action_type: IntelligenceActionType;
  entity_type: string; // 'metric' | 'suggestion' | 'artifact' | 'page'
  entity_id?: string | null;
  scope_type?: string | null;
  scope_id?: string | null;
  metadata?: Record<string, unknown>;
}

export async function logIntelligenceView(payload: IntelligenceAuditPayload): Promise<void> {
  try {
    const { data: auth } = await supabase.auth.getUser();
    const user_id = auth?.user?.id;
    if (!user_id) return;
    await (supabase.from('opti_intelligence_audit_log' as never) as any).insert({
      user_id,
      action_type: payload.action_type,
      entity_type: payload.entity_type,
      entity_id: payload.entity_id ?? null,
      scope_type: payload.scope_type ?? null,
      scope_id: payload.scope_id ?? null,
      metadata: payload.metadata ?? {},
    });
  } catch {
    // intentional swallow — audit is best-effort
  }
}
